// extracted by mini-css-extract-plugin
export default {"root":"App_root__VzAdc","blob1":"App_blob1__uw4a6","blob2":"App_blob2__GxsWj","blob3":"App_blob3__g16Ol"};